import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { CreateOrgArgsType, Org } from "@reflag/shared/organizationAPI";

export function useOrgCreateMutation() {
  return useMutation<Org, AxiosError<ErrorResponse>, CreateOrgArgsType>({
    mutationFn: (data) =>
      api.post<"/orgs">("/orgs", data).then((res) => res.data.org),
  });
}
